import * as React from 'react'
import { UBER_EATS_STAGE_LABELS, UBER_EATS_TIME_PILL_STYLES } from '../../constants/UberEats'
import { UberEatsUrgencyStage } from '../../models/UberEats/UberEatsModels'

interface Props {
  stage: UberEatsUrgencyStage | 'expired'
  timeLabel: string
  testId?: string
}

export const UberEatsStageBadge = ({ stage, timeLabel, testId }: Props) => {
  const { ink, bg, border } = UBER_EATS_TIME_PILL_STYLES[stage]

  return (
    <span
      data-testid={testId}
      data-stage={stage}
      style={{
        display: 'inline-block',
        padding: '2px 10px',
        borderRadius: 12,
        backgroundColor: bg,
        color: ink,
        border: border ? `1px solid ${border}` : '1px solid transparent',
        fontWeight: 600,
      }}
    >
      {UBER_EATS_STAGE_LABELS[stage]}
      {stage !== 'expired' && ` · ${timeLabel}`}
    </span>
  )
}
